export default "__VITE_ASSET__2a6fa60e__"